import PropertyDynamicAttributes from "./PropertyDynamicAttributes";
import { CORE_FACT_DEFINITIONS, collectAttributeValues } from "../../../utils/propertyDetailAttributes";
import { useLocale } from "../../../intl";

const PropertyFactsGrid = ({ property }) => {
  const { t } = useLocale();
  const facts = collectAttributeValues(property, CORE_FACT_DEFINITIONS);

  if (!facts.length) {
    return null;
  }

  return (
    <section className="property-detail-section" aria-label={t("realEstate.keyFacts")}>
      <h2 className="property-detail-section__title">{t("realEstate.keyFacts")}</h2>
      <PropertyDynamicAttributes items={facts} columns={2} />
    </section>
  );
};

export default PropertyFactsGrid;
